import {
    SHIP_MATERIAL_LIST_GET,
    SHIP_MATERIAL_LIST_GET_F,
    SHIP_MATERIAL_LIST_GET_R,
    SHIP_MATERIAL_SELECTED_SET
} from '../actionType'

const initialState = {
    material: [],
    isLoading: false,
    error: null,
    totalPage: 0,
    totalElement: 0,
    selectedShipMaterial: null,
}

export default function ShipMaterialReducer (state = initialState, action : any)  {
    switch (action.type) {
        case SHIP_MATERIAL_LIST_GET:
            return {
            ...state,
            isLoading: true,
            error: null
            }
        case SHIP_MATERIAL_LIST_GET_F:
            // console.log('action called')
            // console.log(action.payload.content,'content')
            return {
                ...state,
                isLoading: false,
                material: action.payload.content,
                totalPage: action.payload.total_page,
                totalElement: action.payload.total_element
            }
        case SHIP_MATERIAL_LIST_GET_R:
            
            return {
                ...state,
                isLoading: false,
                error: action.payload
            }
        case SHIP_MATERIAL_SELECTED_SET:
            return {
                ...state,
                selectedShipMaterial: action.payload
            }
        default:
            return state
    }
}